
import { defineComponent, ref, computed, inject, onMounted } from "vue";
import axios from "axios";
import { useField, useForm } from "vee-validate";
import { store } from "@/store";
import { ActionTypes } from "@/store/actions";

export default defineComponent({
  name: "SignUp",
  emits: ["selectLogin"],
  setup(_, { emit }) {
    const closeModal = inject("closeModal") as () => void;

    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const loading = ref(false);

    const openForgotPass = () => {
      store.dispatch(ActionTypes.SET_MODAL, "forgotPassword");
    };

    const selectLogin = () => {
      emit("selectLogin");
    };

    const signUpSchema = {
      email(value: string) {
        if (!value) {
          return "An email is required";
        }

        if (!value.match(emailRegex)) {
          return `${value} is not a valid email`;
        }

        return true;
      },
      password(value: string) {
        if (!value) {
          return "A password is required";
        }

        if (value.length < 3) {
          return "Password length must be at least three characters";
        }

        return true;
      },
      confirmPassword(value: string) {
        if (!value) {
          return "Please confirm your password";
        }

        if (value !== password.value) {
          return "Passwords must match";
        }

        return true;
      },
    };

    useForm({
      validationSchema: signUpSchema,
    });

    const {
      value: email,
      meta: emailMeta,
      errorMessage: emailError,
      handleChange: handleChangeEmail,
    } = useField("email");

    const {
      value: password,
      meta: passwordMeta,
      errorMessage: passwordError,
      handleChange: handleChangePassword,
    } = useField("password");

    const {
      value: confirmPassword,
      meta: confirmPasswordMeta,
      errorMessage: confirmPasswordError,
      handleChange: handleChangeConfirmPassword,
    } = useField("confirmPassword");

    const generalError = ref("");
    const registeredError = ref(false);
    const canSubmit = computed<boolean>(
      () => emailMeta.valid && passwordMeta.valid && confirmPasswordMeta.valid
    );

    const handleSubmit = async () => {
      loading.value = true;

      try {
        let res = await axios.post(
          `${process.env.VUE_APP_API_URL}/editor/customers/ajax.php?mode=signUp`,
          {
            email: email.value,
            password: password.value,
          }
        );

        if (typeof res.data.error !== "undefined") {
          if (res.data.message.includes("We see you already have an account")) {
            registeredError.value = true;
          } else {
            generalError.value = res.data.message;
          }
        } else {
          generalError.value = "";
          registeredError.value = false;

          closeModal();
        }

        loading.value = false;
      } catch (e) {
        console.log(e);
        loading.value = false;
      }
    };

    return {
      loading,
      openForgotPass,
      email,
      emailError,
      handleChangeEmail,
      password,
      passwordError,
      handleChangePassword,
      confirmPassword,
      confirmPasswordError,
      handleChangeConfirmPassword,
      selectLogin,
      canSubmit,
      handleSubmit,
      registeredError,
      generalError,
    };
  },
});
